import React, { FC, memo, useContext, lazy, useEffect } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import WithRole from '../../user/WithRole';
import NoEvents from '../../emptyStates/NoEvents';
import EventsContentHeader from './EventsContentHeader';
import JoinEventButton from '../../buttons/JoinEventButton';
import CreateEventButton from '../../buttons/CreateEventButton';
import DjFinanceStatusBar from '../../common/DjFinanceStatusBar';
import { SortContext } from '../../context/SortContext';
import { IntercomContext } from '../../context/IntercomContext';

import { useEvents } from '../../context/EventsContext';
import { getEventInfoForIntercom } from '../../../services/events/helpers';

import { UserRole } from '../../../types/enums';
import { EventsListProps } from './interfaces';

import useStyles from './style';

const EventsDJView = lazy(() => import('./views/EventsDjView'));
const EventsUserView = lazy(() => import('./views/EventsUserView'));

const EventsList: FC<EventsListProps> = props => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { firstEventData, setFirstEventData } = useContext(IntercomContext);
  const { sort, setSort } = useContext(SortContext);
  const { eventsData, loading, queryKey, isFilterApplied, isHistory } = useEvents();

  const eventsDefaultProps = {
    ...props,
    sort,
    setSort,
  };

  useEffect(() => {
    if (!firstEventData && eventsData.events.length === 1) {
      const eventPreviewData = getEventInfoForIntercom(eventsData.events[0]);

      setFirstEventData(eventPreviewData);
    }
  }, [eventsData.events.length]);

  return (
    <>
      <div className={classNames(classes.eventsList, props.className)}>
        {isFilterApplied || !!eventsData.totalCount || (!eventsData.totalCount && loading) ? (
          <>
            <EventsContentHeader eventsCount={eventsData.totalCount} eventsType={t(queryKey)} />
            <>
              <WithRole roles={[UserRole.dj]}>
                <EventsDJView {...eventsDefaultProps} />
              </WithRole>
              <WithRole roles={[UserRole.user]}>
                <EventsUserView {...eventsDefaultProps} />
              </WithRole>
            </>
          </>
        ) : loading ? null : (
          <NoEvents>
            <div>{t(isHistory ? 'eventsHistoryEmptyState' : 'eventsUpcomingEmptyState')}</div>
            {isHistory ? null : (
              <>
                <WithRole roles={[UserRole.dj]}>
                  <CreateEventButton className="centrate" />
                </WithRole>
                <WithRole roles={[UserRole.user]}>
                  <JoinEventButton className="centrate" />
                </WithRole>
              </>
            )}
          </NoEvents>
        )}
      </div>
      <DjFinanceStatusBar />
    </>
  );
};

export default memo(EventsList);
